import React, { useMemo } from 'react';
import { Button, Card, Heading, InlineMessage } from '@innovaccer/design-system';

function ViewResponse(props) {
  const [showCopyMsg, setShowCopyMsg] = React.useState(false);

  const content = useMemo(() => JSON.stringify(props.data, null, 6), [props.data]);

  const handleCopyContent = async () => {
    await navigator.clipboard.writeText(content);
    setShowCopyMsg(true);
    setTimeout(() => setShowCopyMsg(false), 2000);
  };

  return (
    <div>
      <div className="w-100 d-flex align-items-center">
        <Heading size="s" className="ml-6">
          Configuration
        </Heading>
        {showCopyMsg && <InlineMessage appearance="success" className="ml-4" description="Configuration copied!" />}
      </div>
      <div className="p-3">
        <Card className="m-6" shadow="none">
          <div className="my-4 mr-4 d-flex justify-content-end">
            <Button
              data-testid="Copy-config"
              appearance="transparent"
              icon="content_copy"
              onClick={handleCopyContent}
            />
          </div>
          <div className="px-8 pb-6">
            <pre>{content}</pre>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default ViewResponse;
